import * as THREE from 'three';

export const GLOBE_RADIUS = 1.5;

export const PIN_RADIUS = GLOBE_RADIUS + 0.006;

/** Latitude/longitude → point on a sphere of the given radius.
 *  Single source of truth so markers and camera never drift apart. */
export function latLngToVec3(lat: number, lng: number, radius = GLOBE_RADIUS): THREE.Vector3 {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lng + 180) * (Math.PI / 180);
  return new THREE.Vector3(
    -radius * Math.sin(phi) * Math.cos(theta),
    radius * Math.cos(phi),
    radius * Math.sin(phi) * Math.sin(theta),
  );
}

const _normal = new THREE.Vector3();
const _toCam = new THREE.Vector3();

/** Correct visibility test for a finite perspective camera: the surface point
 *  is visible when its outward normal faces the camera. (worldPos·cameraPos is
 *  wrong — it treats points beyond the horizon as visible.) */
export function isVisibleFromCamera(worldPos: THREE.Vector3, cameraPos: THREE.Vector3): boolean {
  _normal.copy(worldPos).normalize();
  _toCam.copy(cameraPos).sub(worldPos).normalize();
  return _normal.dot(_toCam) > 0.02; // small margin to avoid horizon flicker
}

export function pinFacesCamera(position: THREE.Vector3, cameraPosition: THREE.Vector3): boolean {
  _normal.copy(position).normalize();
  _toCam.copy(cameraPosition).sub(position).normalize();
  return _normal.dot(_toCam) > 0.05;
}

/** Shared handle to the opaque Earth mesh so <Html> labels can occlude behind it. */
export const earthMeshRef: { current: THREE.Mesh | null } = { current: null };

/** Overview camera position, aimed at ~central Europe (lat 40, lng 12) — where
 *  almost every city sits. Facing the Americas (the old default) put every pin
 *  on the hidden far side. Distance frames the whole globe with margin. */
export const HOME_VIEW = latLngToVec3(40, 12, 1).multiplyScalar(5.05);
